// extracted by mini-css-extract-plugin
export default {"orderImage":"OrderItem_orderImage__RG0fa"};